let _reports = [];
const observableReports = new Rx.BehaviorSubject(_reports);

/**
 * @ngdoc service
 * @name repositories.GdprReportsRepository
 *
 * @description
 * This class is used to save/add devices objects.
 */
const GdprReportsRepository = {

    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#replace
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored actions with provided data.
     *
     * @param {Array} data An array with new actions.
     */
    replace(data) {

        _reports = (data || []);
        observableReports.onNext(_reports);

    },

    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#add
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to add a new action to repository.
     *
     * @param {object} action An action object.
     */
    add(report) {

        const indexOfActions = _reports
            .findIndex(_report => String(_report.id) === String(report.id));

        if (indexOfActions === -1) {

            _reports.push(report);

            observableReports.onNext(_reports);

        }

    },

    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#getAll
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all actions from repository.
     *
     * @returns {Array} actions all actions from repository
     */
    getAll() {

        return _reports;

    },

    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#getObservable
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for actios repository.
     * @returns {Object} an observable object for actions repository.
     */
    getObservable() {

        return observableReports;

    },

};

export default GdprReportsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.gdprReportsRepository.js